import { render } from "./HandbookPolicy.vue?vue&type=template&id=3268266e&scoped=true"
import script from "./HandbookPolicy.vue?vue&type=script&lang=js"
export * from "./HandbookPolicy.vue?vue&type=script&lang=js"

import "./HandbookPolicy.vue?vue&type=style&index=0&id=3268266e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3268266e"]])

export default __exports__